export default __webpack_public_path__ + "static/checknlearn-promo@3x-5b304341cef867ccf27b409136bb7b99.jpg";